 <template>
  <div>
    <v-app-bar
      flat
      color="transparent"
    >
      <v-toolbar-title>
        BestBooks Settings
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <div>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save States Order</v-btn>
      </div>
      <!-- <v-row
        v-if="showSearch"
        align="center"
        style="max-width: 300px;"
      >
        <v-text-field
          flat
          hide-details
          single-line
          label="Search name, email or phone number"
          class="hidden-sm-and-down"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>
      <v-btn
        class="ml-5"
        icon
        @click="showSearch = !showSearch"
      >
        <img
          src="@/assets/icons/search.svg"
          alt=""
        >
      </v-btn> -->
    </v-app-bar>
    <div
      class="pa-4"
      id="best-promo-list"
    >
      <v-row class="border-bot">
        <v-col md="3"><b>State</b></v-col>
        <v-col md="3"><b>Page Header</b></v-col>
        <v-col md="3"><b>Page Description</b></v-col>
        <v-col md="3"></v-col>
      </v-row>
      <draggable
        v-model="best_books_states"
        group="people"
        @start="drag=true"
        @end="drag=false"
        class="list-group"
      >
        <v-row
          v-for="(list, i) in best_books_states"
          :key="i"
          class="clickable border-bot list-group-item"
        >
          <v-col md="3">
            {{  list.state.name }}
          </v-col>
          <v-col md="3">
            {{  list.best_books_title }}
          </v-col>
          <v-col md="3">
            {{  list.best_books_description }}
          </v-col>
          <v-col
            md="3"
            class="kebab-menu"
          >
            <v-menu
              transition="slide-x-transition"
              bottom
              right
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="hoverable"
                  v-bind="attrs"
                  v-on="on"
                >mdi-dots-vertical</v-icon>
              </template>
              <v-list>
                <v-list-item class="hoverable">
                  <v-list-item-title @click="editRecord(list.id)">
                    <v-icon>mdi-file-edit</v-icon>Edit
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="hoverable">
                  <v-list-item-title @click="triggerDelete(list.id, i)">
                    <v-icon>mdi-delete</v-icon>Delete
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row v-if="loading">
          <v-col
            md="3"
            v-for="n in 4"
            :key="n"
          >
            <v-skeleton-loader type="list-item" />
          </v-col>
        </v-row>
      </draggable>
    </div>
    <!-- <div
      class="text-center mt-2 mb-8"
      v-if="listMeta.last_page > 1"
    >
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="listMeta.last_page"
        :total-visible="10"
        circle
      ></v-pagination>
    </div> -->
    <v-overlay
      absolute
      :value="updating"
    >
      <v-dialog
        v-model="updating"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
    <v-btn
      color="success"
      fab
      large
      dark
      bottom
      right
      fixed
      class="mb-4"
      :to="{name: 'bestbooks-settings.create'}"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
      v-model="confirmDeleteDialog"
      persistent
      max-width="360"
    >
      <v-card>
        <v-card-title class="headline">
          <p class="confirm-delete">Are you sure you want to delete this record?</p>
        </v-card-title>
        <v-card-text>Delete Record.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDeleteDialog = false"
          >No</v-btn>
          <v-btn
            @click="deleteSBCategory"
            color="red darken-1 white--text"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'
import draggable from 'vuedraggable'
import map from 'lodash/map'

const initialData = {
  app_state_ids: []
}

export default {
  name: 'BestBookSettingsPage',
  data () {
    return {
      confirmDeleteDialog: false,
      loading: false,
      updating: false,
      loading_message: 'Fetching Data',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      to_delete_id: null,
      to_delete_index: null,
      form: new Form({
        ...initialData
      }),
      best_books_states: [],
    }
  },

  components: {
    draggable
  },

  computed: {
    ...mapState({
      recordList: state => state.bestBookSettings.list,
      listMeta: state => state.bestBookSettings.listMeta,
      requestStatus: state => state.bestBookSettings.requestStatus,
      requestMsg: state => state.bestBookSettings.requestMsg
    })
  },

  methods: {
    ...mapActions({
      getList: 'bestBookSettings/getList',
      updateRecord: 'bestBookSettings/update',
      deleteRecord: 'bestBookSettings/delete',
      updateOrder: 'bestBookSettings/updateOrder',
    }),

    editRecord (id) {
      this.$router.push({ name: 'bestbooks-settings.edit', params: { id } })
    },

    triggerDelete (id, index) {
      this.confirmDeleteDialog = true
      this.to_delete_id = id
      this.to_delete_index = index
    },

    async deleteSBCategory () {
      this.updating = true
      this.confirmDeleteDialog = false
      this.loading_message = 'Deleting Record.'
      await this.deleteRecord(this.to_delete_id)
        .then(response => {
          this.recordList.splice(this.to_delete_index, 1)
          this.showSnackbar(this.requestMsg)
          this.updating = false
        })
        .catch(err => {
          console.log(err)
          this.showSnackbar(this.requestMsg)
        })
    },

    async fetcRecordList () {
      let params = {}

      params.sort = '-created_at'
      params.per_page = 'all'
      this.updating = true
      this.loading_message = 'Fetching Data'
      await this.getList(params)
      this.updating = false
    },

    showSnackbar (message) {
      this.snackbar.color = this.requestStatus
      this.snackbar.message = message
      this.snackbar.show = true
    },

    pageChanged () {
      this.fetcRecordList()
    },

    async onSave () {

      try {
        this.form.app_state_ids = map(this.best_books_states, item => {
          return item.id
        })
        this.form.$busy = true
        this.updating = true
        this.form.$clearErrors()
        const data = this.form.$data()


        await this.updateOrder(data)

        this.showSnackbar(this.requestMsg)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.')
          }
        } else {
          this.showSnackbar(error)
        }
      } finally {
        this.form.$busy = false
        this.updating = false
      }
    }
  },

  created () {
    this.fetcRecordList()
  },

  filters: {
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  },

  watch: {
    recordList: {
      immediate: true,
      handler (val) {
        if (val) {
          this.best_books_states = val
        }
      }
    }
  },
}
</script>

<style scoped>
.hoverable:hover {
  cursor: pointer;
}
.clickable {
  cursor: pointer;
  border-width: 1px;
}
.clickable:hover {
  background-color: #eeeeee;
}
.border-bot {
  border-width: 1px;
  border-bottom: inset;
}
.kebab-menu {
  text-align: end;
}
</style>
